import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { NodeHotKey } from 'libs/editor/plugins/helpers/nodeHotKey';
import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';

const CodeLineNode = observer(({ attributes, children }) => (
  <Pre {...attributes}>{children}</Pre>
));

const Pre = styled.pre`
  font-size: 0.8em;
  white-space: pre-line;
`;

export function CodeLine() {
  return {
    plugins: [
      NodeHotKey({ key: '', type: 'code_line' }),
      RenderNode('code_line', props => <CodeLineNode {...props} />),
    ],
  };
}
